import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  dialogPaper: {
    width: "100%",
    minHeight: "500px",
  },
  buttons: {
    justifyContent: "space-between",
  },
  button: {
    minWidth: "100px",
  },
}))

export default styles
